export default __webpack_public_path__ + "static/cloud-2-82365b0cf79b9be1e3bea62afd698c3e.png";